import React from 'react';
import cx from 'classnames';
import Checkbox from '../../../../../components/Checkbox';
import Select from '../../../../../components/Select';
import { ContactFormConfig } from '../../../../../types/ContactForm';
import styles from '../SettingTab.module.scss';

interface GlobalSettingsProps {
    config: ContactFormConfig;
    updateConfig: (property: string, value: unknown) => void;
}

export const GlobalSettings: React.FC<GlobalSettingsProps> = ({ config, updateConfig }) => {
    return (
        <div className={cx(styles['global-settings'])}>
            <h5>Globale Einstellungen</h5>
            <Checkbox
                property="enableCaptcha"
                value={config.enableCaptcha}
                onChange={() => updateConfig('enableCaptcha', !config.enableCaptcha)}
                label="Captcha aktivieren"
                classes={'zr-mb-4'}
            />

            {config.enableCaptcha && (
                <div className="zr-mt-3 zr-w-50">
                    <Select
                        options={[
                            { value: 'math', label: 'Mathematisches Captcha' },
                            { value: 'google_recaptcha', label: 'Google reCAPTCHA' }
                        ]}
                        value={config.captchaType || 'math'}
                        onSelect={(property, value) => updateConfig('captchaType', value)}
                        property="captchaType"
                        placeholder="Captcha Typ auswählen"
                        searchable={false}
                    />
                    <small className="form-text text-muted d-block zr-mt-1">
                        {config.captchaType === 'google_recaptcha'
                            ? 'Stellen Sie sicher, dass das Google reCAPTCHA Plugin installiert und konfiguriert ist.'
                            : 'Einfaches mathematisches Captcha für grundlegenden Spam-Schutz.'
                        }
                    </small>
                </div>
            )}
        </div>
    );
};

